
import BytedIconCloseSmall from '@byte-design/vue-icons/icons/CloseSmall';
import { defineComponent, computed, ref, onBeforeUnmount } from 'vue-demi';

const name = 'PopupVideoPreview';
export default defineComponent({
  name,
  components: {
    BytedIconCloseSmall,
  },
  props: {
    minHeight: {
      type: String,
      default: 'auto',
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    videoUrl: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const styleObj = computed((): { [index: string]: string } => {
      const { minHeight } = props;
      return { height: '100%', minHeight, borderRadius: '0px', background: 'rgba(0,0,0,0.8)' };
    });
    const video = ref();
    const handleCancel = () => {
      video.value.pause();
      emit('cancel');
    };

    return {
      handleCancel,
      styleObj,
      video,
    };
  },
});
